@if (overlay) {
  <div class="spinner-overlay">
    <div class="spinner-container">
      <i [class]="spinnerClasses"></i>
      @if (message) {
        <span class="spinner-message">{{ message }}</span>
      }
    </div>
  </div>
} @else {
  <i [class]="spinnerClasses"></i>
  @if (message) {
    <span class="spinner-message">{{ message }}</span>
  }
}
